import React from 'react'



const Banner = () => {

    return (
        <>
            <section className="banner-section">
                <div className="container-gt">
                    <div className="one-grid-columns">
                        <div className="grid-child-elem">
                            <div className="banner-text" id= "bannertxt">

                                <h1>
                                Adoption  <span className = "bannertxt">Joys </span>
                                </h1>
                                <div className='banner-line2' id = 'bannerline2'>
                                    {/* <p className="right-sub-text">                            
                                    
                                    They Expected A Miracle
                                   <hr/>
                                   Dads Make a Difference
                                   </p> */}


                                </div>                         

                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner;